import { __name } from './chunk-DCOBXSFB.mjs';

// src/prometheus-metrics.ts
var MetricsRegistry = class {
  static {
    __name(this, "MetricsRegistry");
  }
  counters = [];
  /**
   * Create and register a new counter metric.
   *
   * @param name - The metric name (e.g. "service_request_total")
   * @param help - A human-readable description of the metric
   * @returns A Counter that can be incremented
   */
  createCounter(name, help) {
    const entry = { name, help, value: 0 };
    this.counters.push(entry);
    return {
      inc: /* @__PURE__ */ __name(() => {
        entry.value++;
      }, "inc"),
      add: /* @__PURE__ */ __name((amount) => {
        if (amount < 0) {
          throw new Error("Counter value cannot decrease");
        }
        entry.value += amount;
      }, "add")
    };
  }
  /**
   * Serialize all registered metrics in Prometheus text exposition format.
   *
   * @see https://prometheus.io/docs/instrumenting/exposition_formats/#text-based-format
   */
  metrics() {
    return this.counters.map((c) => {
      let result = "";
      if (c.help.length > 0) {
        result += `# HELP ${c.name} ${c.help}
`;
      }
      result += `# TYPE ${c.name} counter
`;
      result += `${c.name} ${c.value}
`;
      return result;
    }).join("");
  }
};

export { MetricsRegistry };
